import { extendTheme, type ThemeConfig } from "@chakra-ui/react";
import { globalStyles } from "theme/styles";
import { CardComponent } from "./additions/card/Card";
import { CardBodyComponent } from "./additions/card/CardBody";
import { CardFooterComponent } from "./additions/card/CardFooter";
import { CardHeaderComponent } from "./additions/card/CardHeader";
import { ButtonComponent } from "./additions/button/Button";
// import { mode } from "@chakra-ui/theme-tools";

const getStorageColorMode = (): 'light' | 'dark' => {
	const storageColorMode = window.localStorage.getItem('@colorMode')
	return storageColorMode === 'light' ? 'light' : 'dark'
}


const config: ThemeConfig = {
	initialColorMode: getStorageColorMode(),
	useSystemColorMode: false,
  }

export default extendTheme({
	config,
    colors: {
		primary: {
			900: '#F15A22',
			800: '#F47920',
			700: '#F49E00',
			600: '#FD8913',
			500: '#FFD400',
		},
		health: {
			primary: "#216D40",
			light: "#69C49D",
			lighter: "#E5F7EC"
		}
	},
	components: {
		Button: {
			focus: {
				boxShadow: 'none'
			}
		}
	}
	},
	globalStyles,
	CardComponent, // Card component
	CardBodyComponent, // Card Body component
	CardFooterComponent, // Card Footer component
	CardHeaderComponent, // Card Header component
	ButtonComponent, // Card Header component
);
